import React from "react";
import s from "./preload.module.scss"

const Bar = () => {
    return (
        <div className={s.BarBlock}>
            <div className={s.Bar}>
                <div></div><div></div><div></div>
            </div>
        </div>
    )
}

export default Bar;